.wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 6px;
}

.badges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.badge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1px;
  padding: 12px 24px;
  border-radius: 14px;
  min-height: 44px;
}

.primary {
  background: var(--ink);
  color: var(--on-ink);
}

.primary:hover {
  background: #403b32;
  color: var(--on-ink);
}

.secondary {
  border: 1px solid var(--outline);
  color: var(--ink);
}

.secondary:hover {
  background: var(--paper-raised);
}

.small {
  font-size: 11px;
  opacity: 0.75;
}

.secondary .small {
  opacity: 1;
  color: var(--ink-muted);
}

.store {
  font-family: var(--font-display);
  font-size: 16px;
}

.coming {
  font-size: 15px;
  line-height: 1.5;
  color: var(--ink);
}

.note {
  font-size: 13px;
  line-height: 1.5;
  color: var(--ink-muted);
}
